/* Petamomus™ Theme JS */

// Mobile menu toggle
(function() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      const open = nav.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }
})();

// Cart count update
(function() {
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const counts = document.querySelectorAll('.cart-count');
        counts.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      })
      .catch(() => {});
  }
  updateCartCount();
})();

// Variant selection on product pages
(function() {
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const group = this.closest('.variant-buttons');
      if (group) {
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      }
      this.classList.add('active');
    });
  });
})();

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// Pamphlet flip — tap to flip on touch devices
(function() {
  const flips = document.querySelectorAll('.pamphlet-flip');
  flips.forEach(card => {
    card.addEventListener('click', function() {
      this.classList.toggle('flipped');
    });
  });
})();
